import type { ReactNode } from 'react';

import { Flex } from 'ui';

type P = {
  children: ReactNode;
  icon?: ReactNode;
  itemActionProps?: Record<string, unknown>;
};

const SearchItemRow = ({ children, icon, itemActionProps }: P) => (
  <Flex {...itemActionProps} align="center" className="global-search-item" gap="xs">
    {icon}
    {children}
  </Flex>
);

export default SearchItemRow;
